import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  container: {
    border: '0.5px solid #E9E9E9',
  },
});

const Divider = () => {
  const classes = useStyles();

  return <div className={classes.container} />;
};

export default Divider;
